import { Link } from "react-router-dom";
import { Calendar, Clock, User } from "lucide-react";
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import NewsletterSubscription from "@/components/layout/NewsletterSubscription";
import ScrollReveal from "@/components/ScrollReveal";
import { getAllBlogPosts } from "@/data/blogPosts";
import { Badge } from "@/components/ui/badge";
const Blog = () => {
  const posts = getAllBlogPosts();
  return <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      
      <main className="pt-16">
        {/* Header Section */}
        <ScrollReveal>
          <section className="blog-header py-16 bg-gradient-to-b from-muted/50 to-background border-b border-border">
            <div className="container mx-auto px-4 lg:px-8">
              <div className="max-w-3xl mx-auto text-center space-y-6">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold gradient-text">Insights on Building Content Capabilities</h1>
                <p className="text-lg text-muted-foreground leading-relaxed">Deep insights, frameworks, and data-driven analysis on building world-class internal content capabilities for founder-led companies.</p>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Blog Posts Grid */}
        <section className="py-16">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((post, index) => <ScrollReveal key={post.id} delay={index * 100}>
                  <Link to={`/blog/${post.slug}`}>
                    <article className="glass-card p-6 hover-lift h-full flex flex-col">
                      {/* Category and Featured Badge */}
                      <div className="flex items-center gap-3 mb-4">
                        <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
                          {post.category}
                        </Badge>
                        {post.featured && <Badge variant="outline" className="bg-muted text-muted-foreground border-border">
                            Featured
                          </Badge>}
                      </div>

                      {/* Title */}
                      <h2 className="text-xl font-display font-bold text-foreground mb-3 line-clamp-2 flex-grow-0">
                        {post.title}
                      </h2>

                      {/* Excerpt */}
                      <p className="text-muted-foreground leading-relaxed mb-6 line-clamp-3 flex-grow">
                        {post.excerpt}
                      </p>

                      {/* Meta Information */}
                      <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mt-auto">
                        <div className="flex items-center gap-1">
                          <User className="w-4 h-4" />
                          <span>{post.author}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <Calendar className="w-4 h-4" />
                          <span>{post.date}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <Clock className="w-4 h-4" />
                          <span>{post.readTime}</span>
                        </div>
                      </div>
                    </article>
                  </Link>
                </ScrollReveal>)}
            </div>
          </div>
        </section>
      </main>

      <NewsletterSubscription />
      <Footer />
    </div>;
};
export default Blog;